"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeparturePickerValue = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _userflow = require("../../icons-react/userflow");

var DeparturePickerValue = function DeparturePickerValue(props) {
  var isDisabled = props.isDisabled,
      currentValue = props.currentValue,
      children = props.children;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  return isDisabled && currentValue ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.cigarette.mobile.from'), currentValue.selectedLabel), currentValue.isAutomaticallyDetected && /*#__PURE__*/_react["default"].createElement(LocationIcon, null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

exports.DeparturePickerValue = DeparturePickerValue;
var LocationIcon = (0, _styledComponents["default"])(_userflow.SearchLocation).withConfig({
  displayName: "DeparturePickerValue__LocationIcon",
  componentId: "sc-lg01en-0"
})(["width:16px;height:16px;"]);